import { fixFeatureButton, createCustomToggle, customizeSearch, modifySignup } from '../js/helpers';

$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  fixFeatureButton();
  createCustomToggle();
  modifySignup();
  customizeSearch();
});
